<template>
  <div v-if="userHasPermission(constants.PERMISSION_TYPES.MATCH_SCAN, constants.PERMISSION_VALUES.CREATE)">
    <main-header />
    <match-scan-header :manifest-reg-exes="manifestRegExes" @matchScanned="onMatchScanned" />
    <div class="spl-match-scan-table__action-header">
      <form-button @onClick="cleanList">
        Clean List
      </form-button>
      <form-button @onClick="exportToExcel">
        Export Excel
      </form-button>
      <p v-if="matchScannedParcels && matchScannedParcels[today]">
        {{ matchScannedParcels[today].length }} Parcels
      </p>
    </div>
    <div class="spl-match-scan-table">
      <table>
        <thead>
          <tr>
            <th>Counter Number</th>
            <th>Company</th>
            <th>Position</th>
            <th>User</th>
            <th>Timestamp</th>
            <th>Original Barcode</th>
            <th>Weight</th>
            <th>Length</th>
            <th>Width</th>
            <th>Height</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(row, rowIndex) in matchScannedParcels[today]"
            :key="'matchScannedParcel' + rowIndex"
            class="spl-match-scan-table__row">
            <td>{{ row.COUNTER_NUMBER }}</td>
            <td>{{ row.Customer_Name }}</td>
            <td>{{ row.Current_Status_Event_Name }}</td>
            <td>{{ row.Current_Status_Event_User_Name }}</td>
            <td>{{ moment(row.Current_Status_Event_Timestamp).format('YYYY-MM-DD HH:mm') }}</td>
            <td>{{ row.FORWARD_COUNTER_NUMBER }}</td>
            <td>{{ row.Weight }}</td>
            <td>{{ row.Length }}</td>
            <td>{{ row.Width }}</td>
            <td>{{ row.Height }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import constants from '@/constants'
import { find, map } from 'lodash'
import webApi from '@/webApi'
import Helpers from '@/helpers.vue'
// TM1000000245R
// TM1000002157F

export default {
  mixins: [Helpers],
  data () {
    return {
      matchScannedParcels: {},
      today: '',
      manifestRegExes: [],
      moment,
      constants
    }
  },
  mounted () {
    webApi.reference.get_Reference_Manifest().then((result) => {
      this.manifestRegExes = map(result.data, 'RegEx')
    })
    this.today = moment().format('DD.MM.YYYY')
    this.matchScannedParcels = JSON.parse(window.localStorage.getItem('matchScannedParcels')) || {}
  },
  methods: {
    onMatchScanned (parcel) {
      for (const key in constants.REFERENCE_TYPE_NAME) {
        if (Object.prototype.hasOwnProperty.call(constants.REFERENCE_TYPE_ID, key)) {
          const reference = constants.REFERENCE_TYPE_ID[key]
          const foundReference = find(parcel.References, { Reference_Type_ID: reference })
          if (foundReference) {
            parcel[key] = foundReference.Reference_Text
          }
        }
      }
      if (!this.matchScannedParcels[this.today]) {
        this.matchScannedParcels[this.today] = []
      }
      this.matchScannedParcels[this.today].push(parcel)
      window.localStorage.setItem('matchScannedParcels', JSON.stringify(this.matchScannedParcels))
      this.$forceUpdate()
    },
    cleanList () {
      this.matchScannedParcels = {}
      window.localStorage.setItem('matchScannedParcels', {})
      this.$forceUpdate()
    },
    exportToExcel () {
      if (!this.matchScannedParcels[this.today]) {
        return
      }
      var excelList = {
        Columns: [],
        Rows: []
      }

      excelList.Columns.push({ ID: 'COUNTER_NUMBER', Header: 'Counter Number', Type: 'Text' })
      excelList.Columns.push({ ID: 'Customer_Name', Header: 'Company', Type: 'Text' })
      excelList.Columns.push({ ID: 'Current_Status_Event_Name', Header: 'Position', Type: 'Text' })
      excelList.Columns.push({ ID: 'Current_Status_Event_User_Name', Header: 'User', Type: 'Text' })
      excelList.Columns.push({ ID: 'Current_Status_Event_Timestamp', Header: 'Timestamp', Type: 'DateTime' })
      excelList.Columns.push({ ID: 'FORWARD_COUNTER_NUMBER', Header: 'Original Barcode', Type: 'Text' })
      excelList.Columns.push({ ID: 'Weight', Header: 'Weight', Type: 'Number' })
      excelList.Columns.push({ ID: 'Length', Header: 'Length', Type: 'Number' })
      excelList.Columns.push({ ID: 'Width', Header: 'Width', Type: 'Number' })
      excelList.Columns.push({ ID: 'Height', Header: 'Height', Type: 'Number' })

      const todayParcels = this.matchScannedParcels[this.today]
      // add the values
      for (let i = 0; i < todayParcels.length; i++) {
        var rowValues = { Value: [] }
        const parcel = todayParcels[i]
        for (let j = 0; j < excelList.Columns.length; j++) {
          const field = excelList.Columns[j]
          rowValues.Value.push(parcel[field.ID])
        }
        excelList.Rows.push(rowValues)
      }
      // Call the excel download helper
      var today = moment().format('YYYY-MM-DD')
      this.getexcelDownload(excelList, `ReturnMatchScans-${today}.xlsx`)
    }
  }
}
</script>

<style lang="scss">
  @import '../variables.scss';
  .spl-match-scan-table {
    margin: 0 70px;
    overflow: auto;
    width: calc(100% - 138px);

    &__action-header {
      margin: 20px 70px;
      & p {
        display: inline;
      }
    }

    table {
      border-spacing: 0;
      table-layout: fixed;
      border: 0;
    }
    &__head {
      th {
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 3px 5px 0 rgba(0, 0, 0, 0.1);
        border: 0;
      }
      &--sticky {
        position: sticky;
        left: 41px;
        z-index: 3 !important;
      }
      &--checkbox {
        .spl-checkbox {
          margin: 10px 2px 0 6px;
        }
        position: sticky;
        left: 0px;
        z-index: 3 !important;
      }
    }
    &__row {
      &--selected {
        background-color: $tableRowBackgroundColorSelected !important;
      }
      &--deleted {
        opacity: 0.3;
        background-color: lightgrey !important;
      }
      &--return [name='Counter Number'] {
        background-color: #fbd5d5;
      }
    }
    &__field {
      &--number {
        text-align: right;
        width: 70px;
      }
      &--sticky {
        position: sticky;
        left: 41px;
        box-shadow: 3px 0px 3px 0px rgba(0, 0, 0, 0.2);
        background-color: $tableHeaderBackgroundColor;
      }
      &--checkbox {
        .spl-checkbox {
          margin: 0 7px 0 6px;
        }
        position: sticky;
        background-color: $tableHeaderBackgroundColor;
        left: 0;
      }
      &--long {
        max-width: 400px !important;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      &--success {
        border-bottom: 2px solid $green !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $green;
      }
      &--warning {
        border-bottom: 2px solid $darkYellow !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $darkYellow;
      }
      &--error {
        border-bottom: 2px solid $red !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $red;
      }
      &--bold {
        font-weight: 600;
      }
      &--empty:hover {
        background-color: $tableRowBackgroundColorHover !important;
      }
    }
    thead {
      th {
        position: sticky;
        top: 0;
        text-align: left;
        font-family: $mono;
        font-size: 9px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 1px;
        line-height: 12px;
        background-color: $tableHeaderBackgroundColor;
        padding: 0px 5px  0px 5px;
        height: 40px;
        z-index: 2;
        border-bottom: 1px solid $tableHeaderBorderColor;
      }

      th:hover {
        background-color: $tableColumnBackgroundColorHover;
        cursor: pointer;
      }
    }
    tbody {

      tr {
        background-color: $tableRowBackgroundColor;
      }

      tr:hover {
        background-color: $tableRowBackgroundColorHover;
      }

      td {
        border-style: solid;
        border-width: 0 1px 1px 0;
        border-color: $tableRowBorderLowColor;
        border-bottom-color: $tableRowBorderColor;
        font-size: 12px;
        padding: 5px;
        padding-top: 8px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 150px;
      }

      td:hover {
        background-color: $tableColumnBackgroundColorHover;
        cursor: pointer;
      }

      td:first-child {
        border-left-width: 1px;
      }
    }

  }
</style>
